import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setModalOpen,
    setModalType,
    setParseDataOfCsvFile,
    setSelectedCsvFile,
    setSelectedCsvFileName
} from 'store/ResponseTemplate/actions';
import { Button, Box, Grid, FormHelperText, Typography, Stack } from '@mui/material';
import Dropzone from 'Components/DropZone';
import CustomCsvAttachmentBox from 'Components/CustomCsvAttachmentBox';
import { parse } from 'papaparse';

function ImportCsvTemplate() {
    const { selectedCsvFile, selectCsvFileName } = useSelector((state) => state.response);
    const dispatch = useDispatch();
    const [inputFile, setInputFile] = useState();
    let tempFile = null;
    const [name, saveName] = useState('');
    const [formError, setFormError] = useState('');

    useEffect(() => {
        setInputFile(selectedCsvFile);
        saveName(selectCsvFileName);
    }, [selectCsvFileName, selectedCsvFile]);
    const updateInputFile = (file) => {
        setFormError('');
        tempFile = file;
        validateFile(file);
    };

    const onRemoveFile = () => {
        setInputFile();
        tempFile = null;
        onCloseHandler(true);
    };

    /**Download Sampl Csv */
    const handleDownload = () => {
        const csvRows = ['Question, Response'];
        csvRows.push('Question?, Answer goes here.');
        let newCsvRows = csvRows.join('\n');
        const blob = new Blob([newCsvRows], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sample.csv';
        a.click();
        URL.revokeObjectURL(url);
    };

    const checkCsvHeaders = (header) => {
        if (
            header.toString().trim().replaceAll(' ', '').toLowerCase() === 'question,response' ||
            header.toString().trim().replaceAll(' ', '').toLowerCase() === 'response,question'
        )
            return true;
        return false;
    };

    const onCloseHandler = (flag) => {
        if (!flag) dispatch({ type: setModalOpen, modalOpen: false });
        dispatch({ type: setSelectedCsvFile, selectedCsvFile: null });
        dispatch({ type: setSelectedCsvFileName, selectCsvFileName: '' });
        dispatch({ type: setParseDataOfCsvFile, parsedCsvData: [] });
    };
    const formatKeyValues = (data) => {
        let results = [];
        if (data && data?.length) {
            results = data?.map((item) => {
                let newObj = {};
                Object.keys(item).map((key) => {
                    if (key.toLowerCase().includes('question')) newObj = { ...newObj, Question: item[key] };
                    else newObj = { ...newObj, Response: item[key] };
                    return key;
                });
                return newObj;
            });
        }
        return results;
    };
    const handleCSVData = (results) => {
        const headers = results.meta.fields;
        let header = headers.join(',').replaceAll(' ', ' ');

        if (!checkCsvHeaders(header)) {
            setFormError('Invalid csv file format. Please provide correctly formatted csv file.');
        } else {
            setInputFile(tempFile);
            saveName(tempFile?.[0]?.name || '');
            dispatch({ type: setParseDataOfCsvFile, parsedCsvData: formatKeyValues(results?.data) || [] });
        }
    };

    const validateFile = (file) => {
        const fileBackup = file?.[0] || null;
        if (!fileBackup) {
            setFormError('Invalid file');
            return;
        }
        if (fileBackup.type !== 'text/csv') {
            setFormError('File should be in csv format');
            return;
        }
        parse(fileBackup, {
            header: true,
            skipEmptyLines: true,
            complete: handleCSVData
        });
    };

    const onImportClick = () => {
        dispatch({ type: setSelectedCsvFile, selectedCsvFile: inputFile });
        dispatch({ type: setSelectedCsvFileName, selectCsvFileName: name });
        dispatch({ type: setModalOpen, modalOpen: true });
        dispatch({ type: setModalType, modalType: 'list_csv_data' });
    };

    return (
        <Stack gap="36px" p={3}>
            <Stack gap={2}>
                <Typography component="h3" color="#00214D" fontSize="1.25rem" fontWeight="400" fontFamily="Poppins">
                    Import via CSV
                </Typography>
                <Typography component="span" className="text-subtitle-import-csv" color="#676767" fontSize="0.875rem" lineHeight="1.4">
                    If you already have a question registry prepared, you can import it directly here. Please see the format of which to
                    import the CSV file:
                </Typography>
                <Stack direction="row" justifyContent="flex-start">
                    <Button className="alternate-reversed" onClick={handleDownload}>
                        Example CSV
                    </Button>
                </Stack>

                <Box
                    sx={{
                        '.drag-upload .drag-field': {
                            minHeight: '250px'
                        }
                    }}
                >
                    {!inputFile && (
                        <Dropzone
                            fileTypes={['CSV']}
                            updateInputFile={updateInputFile}
                            isMultiple={false}
                            disableAttachments={true}
                            hideMessage={true}
                            setFormError={setFormError}
                        />
                    )}
                    {inputFile && <CustomCsvAttachmentBox onRemoveHandler={onRemoveFile} fileName={name} />}
                    {formError && (
                        <FormHelperText error id="standard-weight-helper-text--register" className="mb-0">
                            {formError}
                        </FormHelperText>
                    )}
                </Box>
            </Stack>
            <Stack direction="row" justifyContent="flex-end" gap={2}>
                <Button className="alternate-reversed" onClick={() => onCloseHandler(false)}>
                    Cancel
                </Button>
                <Button className="alternate" disabled={!inputFile} onClick={onImportClick}>
                    Import
                </Button>
            </Stack>
        </Stack>
    );
}

export default ImportCsvTemplate;
